import { render, staticRenderFns } from "./printing_settings.vue?vue&type=template&id=7c04799a"
import script from "./printing_settings.vue?vue&type=script&lang=js"
export * from "./printing_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports